import React from 'react';
import { Stepper, Step, StepLabel, StepContent } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormQuestions from './FormQuestions';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    }
}));

const StepperQuestions = props => {

    const { 
            activeStep, 
            steps, 
            orientation, 
            handleNext, 
            question,
            answer, 
            dataquestions, 
            handleChangeQuestion,
            handleChangeAnswer,
            handleBack,
            formErrors,
            type,
            setType 
        } = props;

    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Stepper activeStep={activeStep} orientation={orientation}>

                {steps.map((item, index) => (
                    <Step key={index}>
                        <StepLabel>{item.title}</StepLabel>
                        <StepContent>
                            <FormQuestions 
                                handleNext = {handleNext}
                                handleBack = {handleBack}
                                question = {question}
                                answer = {answer}
                                dataquestions = {dataquestions}
                                handleChangeQuestion = {handleChangeQuestion}
                                handleChangeAnswer = {handleChangeAnswer}
                                activeStep = {activeStep}
                                formErrors = {formErrors}
                                type = { type }
                                setType = { setType }
                            />
                        </StepContent>
                    </Step>
                ))}
                
            </Stepper>
        </div>
    );
}

export default StepperQuestions;